export default __webpack_public_path__ + "static/media/p2.62541e3b.png";